import { StrictOmit } from "@instacover/utils"
import { UpdateSpec } from "dexie"

import { Session, Tables } from "@/database/helpers/tables"
import { Repository } from "@/database/helpers/types"
import { logger } from "@/utils/logging"
import { PartialBy } from "@/utils/types"

type UpsertData = PartialBy<Parameters<Tables["session"]["add"]>[0], "createdAt">

type UpdateParams = {
  instahomeSessionId: string
  data: StrictOmit<UpdateSpec<Session>, "dexieId">
}

export class SessionRepository extends Repository {
  async add(data: UpsertData) {
    const currentDate = new Date()
    await this.dexie.session.add({
      ...data,
      createdAt: data.createdAt ?? currentDate,
    })
  }

  async upsert(data: UpsertData) {
    const record = await this.dexie.session.where("id").equals(data.id).first()
    if (record) {
      await this.dexie.session.update(record.dexieId, { ...data })
      return
    }

    await this.add(data)
  }

  async get(id: string) {
    return await this.dexie.session.where({ id }).first()
  }

  async update(params: UpdateParams) {
    const { instahomeSessionId, data } = params

    logger.info(`Updating session ${instahomeSessionId} with data: ${JSON.stringify(data)}`)

    const session = await this.dexie.session.where("id").equals(instahomeSessionId).first()
    if (!session) {
      logger.warn(`Failed to update session. Session with id ${instahomeSessionId} not found`)
      return
    }

    await this.dexie.session.update(session.dexieId, { ...data, updatedAt: new Date() })
  }
}
